import { useTranslations } from "@/contexts/Translation";
import { InfoMessage } from "../../InfoMessage/InfoMessage";
import { useUserManagement } from "./UserManagementContext";
import Button from "../../Button/Button";
import List from "../../../components/List/List";
import Collapsable from "@/components/Collapsable/Collapsable";
import Card from "@/components/Card/Card";
import styles from "./GroupsSection.module.css";

type ComponentProps = {
  setShowGroups: (show: boolean) => void;
};

const GroupsSection = ({ setShowGroups }: ComponentProps) => {
  const t = useTranslations("userManagementForm");
  const { groups } = useUserManagement();

  return (
    <Card className={styles.card} padding='none' variant='collapsable'>
      <Collapsable toggleItem={t("groupsHeading")} closed={false}>
        <InfoMessage>{t("groupsInfo")}</InfoMessage>
        {groups.length === 0 && <InfoMessage>{t("noGroups")}</InfoMessage>}
        {groups.length > 0 && (
          <List
            items={groups.map((d) => (
              <div key={d.id || d.name}>{d.name}</div>
            ))}
          />
        )}

        <Button onClick={() => setShowGroups(true)}>
          {t(groups.length === 0 ? "addGroup" : "editGroups")}
        </Button>
      </Collapsable>
    </Card>
  );
};

export default GroupsSection;
